import React from 'react'
import Text, { DefaultFontProps } from 'library/atoms/Typography/Text'

const H2 = ({ children, ...other }: DefaultFontProps) => {
  return (
    <Text fontStyle="h2" as="h2" {...other}>
      {children}
    </Text>
  )
}

export default H2
